
export function selectFeaturedCarouselItem(evt, $slick, currentSlide, nextSlide) {
    let $featuredCarousel = $slick.$slider.closest('.featured-carousel');

    if (!$featuredCarousel.length) {
        return;
    }

    let carouselControls = $featuredCarousel[0].querySelectorAll('[data-single-slide]'),
        i = 0,
        targetSlide;


    if ( evt.type == 'beforeChange' && nextSlide != undefined ) {
        targetSlide = nextSlide;
    } else {
        targetSlide = currentSlide;
    }

    while (i < carouselControls.length) {
        if ( i == targetSlide ) {
            carouselControls[i].classList.add('selected');
        } else {
            carouselControls[i].classList.remove('selected');
        }

        i++
    }
}

export function featuredCarouselInit(evt, $slick) {
    let $featuredCarousel = $slick.$slider.closest('.featured-carousel');

    if (!$featuredCarousel.length) {
        return;
    }

    let carouselControls = $featuredCarousel[0].querySelectorAll('[data-single-slide]');

    [].forEach.call(carouselControls, function(singleControl, index = 0) {
        function gotoIndex() {
            let currentIndex = $slick.slickCurrentSlide();

            if ( currentIndex != index - 1) {
                $slick.slickGoTo(index - 1);
            }
        }

        singleControl.addEventListener('mouseenter', gotoIndex)

        singleControl.addEventListener('mouseenter', function() {
            $slick.slickPause();
        })

        singleControl.addEventListener('mouseleave', function() {
            $slick.slickPlay();
        })
        index++;
    })
}

export function getOffsetArrow(type, label) {
    return '<button class="slick-arrow--offset slick-' + type + '--offset"><span class="visually-hidden">' + label + '</span></button>';
}
